export class Smartphone {
    constructor(ua = window.navigator.userAgent) {
        this.ua = ua;
    }

    isAndroid() {
        return !!(!this.isWindowsMobile() && this.ua.match(/Android/i));
    }

    isIOS() {
        return !!(!this.isWindowsMobile() && (this.isIPhone() || this.isIPad()));
    }

    isIPhone() {
        // Added this validation because of windows 8.1 useragent that has iPhone on it, check below.
        return !!(!this.isWindowsMobile() && this.ua.match(/iPhone|iPod/i));
    }

    isIPad() {
        return !!this.ua.match(/iPad/i);
    }

    isWindowsMobile() {
        return !!this.ua.match(/IEMobile|Windows Phone/i);
    }

    isAny() {
        return !!(this.isAndroid() || this.isIOS() || this.isWindowsMobile());
    }

    type() {
        // Verify windows phone first because some windows phone user agents have iphone in it
        // ex: Mozilla/5.0 (Mobile; Windows Phone 8.1; Android 4.0; ARM; Trident/7.0; Touch; rv:11.0; IEMobile/11.0; Microsoft; Lumia 535 Dual SIM) like iPhone OS 7_0_3 Mac OS X AppleWebKit/537 (KHTML, like Gecko) Mobile Safari/537
        if (this.isWindowsMobile()) {
            return 'winphone';
        } else if (this.isAndroid()) {
            return 'android';
        } else if (this.isIPhone()) {
            return 'iphone';
        } else if (this.isIPad()) {
            return 'ipad';
        }
        return 'nonmobile';
    }
}
